import React, { Component } from 'react'
import './_styles.scss'

/**
 * StandingsTable
 * Standings table for a single group.
 *
 * Props:
 *  - rows {array} Array of row objects:
 *    {
 *      position : number,
 *      team     : { id: string, name: string, flagUrl: string|null },
 *      pj       : number,
 *      g        : number,
 *      e        : number,
 *      p        : number,
 *      gf       : number,
 *      gc       : number,
 *      dg       : number,
 *      pts      : number,
 *      qualifies: boolean
 *    }
 *  - highlightTeamId {string} ID del equipo cuyas celdas deben resaltarse
 *  - highlightColor {string} Color a aplicar a las celdas resaltadas (ej: '#ff0000', 'red')
 */


function formatDg (dg) {
  if (dg > 0) return '+' + dg
  return String(dg)
}

class StandingsTable extends Component {
  constructor (props) {
    super(props)
  }

  renderHeader () {
    const { headers } = this.props

    if(!headers || headers.length === 0) return null

    return (
      <div className='standings-table__header'>
        <span className='standings-table__cell standings-table__cell--pos'>{headers[0].label}</span>
        <span className='standings-table__cell standings-table__cell--team'>{headers[1].label}</span>
        {headers.slice(2).map(function (col) {
          return (
            <span
              key={col.key}
              className={'standings-table__cell standings-table__cell--stat'}
            >
              {col.label}
            </span>
          )
        })}
      </div>
    )
  }

  renderRow (row, index) {
    const { highlightTeamId, highlightColor } = this.props
    const qualifiesClass = row.qualifies ? ' standings-table__row--qualifies' : ''
    const team = row.team || {}
    const isHighlighted = highlightTeamId && team.id === highlightTeamId
    const cellStyle = isHighlighted && highlightColor ? { backgroundColor: highlightColor } : {}

    return (
      <div key={team.id || index} className={'standings-table__row' + qualifiesClass}>
        <span className='standings-table__cell standings-table__cell--pos' style={cellStyle}>
          {row.position}
        </span>

        <span className='standings-table__cell standings-table__cell--team' style={cellStyle}>
          {team.flagUrl
            ? (
              <img
                className='standings-table__flag'
                src={team.flagUrl}
                alt={team.name || ''}
              />
            )
            : <span className='standings-table__flag-placeholder' />
          }
          <span className='standings-table__team-name'>{team.name || 'Por definir'}</span>
        </span>

        {Object.keys(row)
          .filter(function (key) {
            return key !== 'position' && key !== 'team' && key !== 'qualifies'
          })
          .map(function (key) {
            const value = key === 'dg' ? formatDg(row[key]) : row[key]
            return (
              <span key={key} className='standings-table__cell standings-table__cell--stat' style={cellStyle}>
                {value}
              </span>
            )
          })
        }
      </div>
    )
  }

  render () {
    const { rows, bodyRef, bodyClassName, footer } = this.props
    const data = rows || []

    return (
      <div className='standings-table'>
        {this.renderHeader()}
        <div
          className={'standings-table__body' + (bodyClassName ? ' ' + bodyClassName : '')}
          ref={bodyRef}
        >
          {data.map((row, index) => this.renderRow(row, index))}
          {footer || null}
        </div>
      </div>
    )
  }
}

export default StandingsTable



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/TablaDePosiciones/Components/StandingsTable/index.jsx